import { DrawerSection } from '../drawer/DrawerSection';
import { Box, Stack } from '@mui/material';
import { TitleInput } from './TitleInput';
import { CustomAttributes } from './CustomAttributes';
import { useBuilder } from '../context';
import { TextArea } from 'framework/form';

export const FormSettings = () => {
  const { form, edit } = useBuilder();

  return (
    <Box sx={{ '.floating-label-input, .floating-label-dropdown': { mb: 0 } }}>
      <DrawerSection
        sections={[
          {
            id: 'general',
            title: 'General',
            content: (
              <Stack useFlexGap spacing={2}>
                <TitleInput title={form.title} onTitle={title => edit({ kind: 'setTitle', title })} />
                <TextArea
                  source="description"
                  rows={3}
                  label="Description"
                  value={form.description ?? ''}
                  onChangeCallback={({ description }) => edit({ kind: 'setDescription', description })}
                />
              </Stack>
            ),
          },
          {
            id: 'customAttributes',
            title: 'Custom attributes',
            content: (
              <CustomAttributes
                attributes={form.customAttributes}
                onAttributes={customAttributes => edit({ kind: 'setCustomAttributes', customAttributes })}
              />
            ),
          },
        ]}
      />
    </Box>
  );
};
